import { connect } from "react-redux";
import B2CViewDetails from "./B2CViewDetails";
import { bindActionCreators } from "redux";
import {
    caseByIdRequest,
    caseStatusUpdateRequest,
    loanAccountRequest,
    loanApplicationByIdRequest,
    loanApprovalRequestRequest
} from "../../../../../services/redux/CarLoan/action";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    caseByIdResponse : state.CarLoan.caseByIdResponse,
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
    loanApplicationByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanAccountResponse : state.CarLoan.loanAccountResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    loanApprovalRequestResponse: state.CarLoan.loanApprovalRequestResponse
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseByIdRequest,
        caseStatusUpdateRequest,
        loanApplicationByIdRequest,
        loanAccountRequest,
        documentUploadUrlPublic,
        loanApprovalRequestRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(B2CViewDetails);